import React, { useState } from 'react';
import { FiShield, FiAlertTriangle, FiX, FiCheck } from 'react-icons/fi';
import { useLanguage } from '../contexts/LanguageContext';
import './SecurityWarning.css';

const SecurityWarning = ({ onAccept, onDismiss }) => {
  const { texts } = useLanguage();
  const [understood, setUnderstood] = useState(false);

  return (
    <div className="security-warning-overlay">
      <div className="security-warning-modal">
        <div className="security-warning-header">
          <FiShield className="security-icon" />
          <h2>{texts.security.title}</h2>
        </div>
        
        <div className="security-warning-content">
          <div className="warning-section">
            <FiAlertTriangle className="warning-icon" />
            <h3>{texts.security.warningTitle}</h3>
            <ul>
              {texts.security.warnings.map((warning, index) => (
                <li key={index}>{warning}</li>
              ))}
            </ul>
          </div>

          <div className="security-measures">
            <FiShield className="shield-icon" />
            <h3>{texts.security.securityTitle}</h3>
            <ul>
              {texts.security.securityMeasures.map((measure, index) => (
                <li key={index}>
                  <FiCheck className="check-icon" /> {measure}
                </li>
              ))}
            </ul>
          </div>

          <div className="responsibility-notice">
            <p>
              <strong>{texts.security.disclaimer}</strong>
              {texts.security.disclaimerText}
            </p>
          </div>

          <div className="checkbox-container">
            <label>
              <input 
                type="checkbox" 
                checked={understood} 
                onChange={(e) => setUnderstood(e.target.checked)}
              />
              {texts.security.agreementText}
            </label>
          </div>

          <div className="security-warning-actions">
            <button 
              className="accept-button" 
              onClick={onAccept}
              disabled={!understood}
            >
              {texts.security.acceptButton}
            </button>
            <button className="dismiss-button" onClick={onDismiss}>
              <FiX /> {texts.security.cancelButton}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityWarning;